import React from 'react';
import { Button } from './ui/button';
import { AlertTriangle, CheckCircle, Trash2, ArrowRightCircle } from 'lucide-react';

const iconMap = {
  warning: <AlertTriangle className="w-6 h-6 text-amber-500" />,
  danger: <Trash2 className="w-6 h-6 text-red-500" />,
  success: <CheckCircle className="w-6 h-6 text-emerald-500" />,
  convert: <ArrowRightCircle className="w-6 h-6 text-blue-500" />,
};

const colorMap = {
  warning: 'bg-amber-600 hover:bg-amber-700',
  danger: 'bg-red-600 hover:bg-red-700',
  success: 'bg-emerald-600 hover:bg-emerald-700',
  convert: 'bg-blue-600 hover:bg-blue-700',
};

export const ConfirmDialog = ({ open, title, message, confirmText = 'Confirm', cancelText = 'Cancel', variant = 'warning', onConfirm, onCancel }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="confirm-dialog">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm p-6 animate-in fade-in zoom-in-95 duration-150">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0">
            {iconMap[variant] || iconMap.warning}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-slate-900 text-base" data-testid="confirm-dialog-title">{title}</h3>
            <p className="text-sm text-slate-500 mt-1">{message}</p>
          </div>
        </div>
        <div className="flex gap-2 mt-5">
          <Button variant="outline" className="flex-1" onClick={onCancel} data-testid="confirm-dialog-cancel">{cancelText}</Button>
          <Button className={`flex-1 text-white ${colorMap[variant] || colorMap.warning}`} onClick={onConfirm} data-testid="confirm-dialog-confirm">{confirmText}</Button>
        </div>
      </div>
    </div>
  );
};
